import "./Observatory.module.css";
import NavigationPortal from "@/reusable_sections/Header";
import TheAstralThreshold from "./sections/TheAstralThreshold";
import Solartelemetryvisualization from "./sections/Solartelemetryvisualization";
import DualCoreExploration from "./sections/DualCoreExploration";
import LiveFromTheLens from "./sections/LiveFromTheLens";
import TheChroniclerSLog from "./sections/TheChroniclerSLog";
import CosmicDialogue from "./sections/CosmicDialogue";
import JoinTheObservation from "./sections/JoinTheObservation";
import ObservatoryFooter from "@/reusable_sections/Footer";
export default function ObservatoryPage() {
  return <div>
      <NavigationPortal />
      <TheAstralThreshold />
      <Solartelemetryvisualization />
      <DualCoreExploration />
      <LiveFromTheLens />
      <TheChroniclerSLog />
      <CosmicDialogue />
      <JoinTheObservation />
      <ObservatoryFooter />
    </div>;
}